import React from "react";
import { Ribbon } from "./Ribbon";
import { COACH_DESTINATIONS } from "./destinations";

/**
 * CoachRibbon — issue #1121 (D221 O1, D223 Q3). The coach's own ribbon,
 * Your players · Grounds · Training & guides, a thin wrapper over `Ribbon`
 * the way `DestinationRow` is for the player. D221 supersedes D92 ("the
 * coach gets no row") and D177 (Training in the account menu) for coaches.
 * `nav-destinations-coach` is its band testid, so the nav guard and the
 * journeys can tell it from the player's `nav-destinations`.
 *
 * `current` is a `COACH_DESTINATIONS` key (`players`, `grounds` or `learn`);
 * omit it on a screen that is none of them (Settings). `grounds` is current on
 * the coach's `/grounds-map` (#1288).
 */
export function CoachRibbon({ current, className = "", "data-testid": testId = "nav-destinations-coach", ...rest }) {
  return <Ribbon items={COACH_DESTINATIONS} currentKey={current} className={className} data-testid={testId} {...rest} />;
}

export default CoachRibbon;
